import axios from 'axios';
import { useEffect, useState } from 'react';
import { Button, Card, Row, Col, Spinner, Container } from 'react-bootstrap';
import { useNavigate, useLocation } from 'react-router-dom';

const ViewCandidateDetails = ({ candidateId, resumeId, appliedOn, setViewCandidate }) => {
    const BASE_API_URL = process.env.REACT_APP_API_URL;
    const navigate = useNavigate();
    const location = useLocation();

    const {
        userEmail,
        userName,
        currentDreamAppPage,
        currentDreamAppPageSize,
        dreamAppStatus,
        dreamAppFromDate,
        dreamAppToDate,
        dreamAppSearch,
    } = location.state || {};

    const [candidateDetails, setCandidateDetails] = useState(null);

    useEffect(() => {
        const fetchDetails = async () => {
            if (!candidateId) return;

            try {
                const response = await axios.get(`${BASE_API_URL}/fetchCandidateDetails`, {
                    params: { candidateId },
                });
                setCandidateDetails(response.data);
            } catch (error) {
                console.error('Error fetching candidate details:', error);
                setCandidateDetails(null);
            }
        };

        fetchDetails();
    }, [candidateId]);

    const [appliedOnText, setAppliedOnText] = useState('');

    useEffect(() => {
        if (!appliedOn) return;

        const today = new Date();
        const appliedDate = new Date(appliedOn);
        const diffTime = today - appliedDate; // difference in milliseconds
        const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

        if (diffDays === 0) {
            setAppliedOnText('Applied today');
        } else if (diffDays === 1) {
            setAppliedOnText('Applied 1 day ago');
        } else if (diffDays > 1 && diffDays <= 7) {
            setAppliedOnText(`Applied ${diffDays} days ago`);
        } else {
            // More than 7 days ago, show actual date (format as needed)
            setAppliedOnText(`Applied on ${appliedDate.toLocaleDateString()}`);
        }
    }, [appliedOn]);

    const handleBack = () => {
        setViewCandidate(false);
    };

    return (
        <Container className="my-0">
            {candidateDetails ? (
                <Card className="shadow-lg border-0">
                    <Card.Header className="d-flex justify-content-between align-items-center  text-black">
                        <h4 className="mb-0">👤 Candidate Details</h4>
                        <Button variant="light" size="sm" onClick={handleBack}>
                            ✖ Close
                        </Button>
                    </Card.Header>
                    <Card.Body>
                        <Row className="mb-3">
                            <Col md={6}>
                                <h6 className="text-muted mb-1">Name</h6>
                                <p className="fw-semibold">{candidateDetails.userName || 'N/A'}</p>
                            </Col>
                            <Col md={6}>
                                <p className="">{appliedOnText || 'N/A'}</p>
                            </Col>
                        </Row>
                        <Row className="mb-3">
                            <Col>
                                <h6 className="text-muted mb-1">Email</h6>
                                <p className="fw-semibold">{candidateDetails.userEmail || 'N/A'}</p>
                            </Col>
                        </Row>

                        <Row className="mb-3">
                            <Col>
                                <h6 className="text-muted mb-1">Skills</h6>
                                <p className="fw-semibold">{candidateDetails.skills || 'N/A'}</p>
                            </Col>
                        </Row>

                        <Row className="mb-3">
                            <Col>
                                <h6 className="text-muted mb-1">Education</h6>
                                {candidateDetails.educationDetails && candidateDetails.educationDetails.length > 0 ? (
                                    candidateDetails.educationDetails.map((edu, index) => (
                                        <p key={index} className="fw-semibold mb-1">
                                            {`${edu.degree || 'N/A'} (${edu.branch?.toUpperCase() || 'N/A'}) from ${edu.college?.toUpperCase() || 'N/A'} - ${edu.percentage ?? 'N/A'}%`}
                                        </p>
                                    ))
                                ) : (
                                    <p className="fw-semibold">N/A</p>
                                )}
                            </Col>
                        </Row>


                        <Row className="mb-3">
                            <Col>
                                <h6 className="text-muted mb-1">Experience</h6>
                                {candidateDetails.experience && candidateDetails.experience.length > 0 ? (
                                    candidateDetails.experience.map((exp, index) => (
                                        <p key={index} className="fw-semibold mb-1">
                                            {`I have ${exp.yearsOfExperience} years of experience at ${exp.lastCompany} as a ${exp.jobRole}.`}
                                        </p>
                                    ))
                                ) : (
                                    <p className="fw-semibold">Fresher</p>
                                )}
                            </Col>
                        </Row>


                        <Row className="mb-3">
                            <Col md={6}>
                                <h6 className="text-muted mb-1">Phone</h6>
                                <p className="fw-semibold">{candidateDetails.phone || 'N/A'}</p>
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>
            ) : (
                <div className="text-center my-5">
                    <Spinner animation="border" variant="primary" />
                    <p className="mt-3">Loading candidate details...</p>
                </div>
            )}
        </Container>

    );
};

export default ViewCandidateDetails;
